export const unsubscribed = "NIGuFe";
export default {unsubscribed};